import React from 'react';
import { Box } from '@mui/material';

const GeometricBackground = ({
  children,
  minHeight = '100%',
  sx,
  ...props
}) => {
  return (
    <Box
      sx={{
        minHeight,
        background: `
          linear-gradient(135deg, color-mix(in srgb, var(--primary) 3%, transparent) 25%, transparent 25%),
          linear-gradient(225deg, color-mix(in srgb, var(--primary) 3%, transparent) 25%, transparent 25%),
          linear-gradient(45deg, color-mix(in srgb, var(--primary) 3%, transparent) 25%, transparent 25%),
          linear-gradient(315deg, color-mix(in srgb, var(--primary) 3%, transparent) 25%, transparent 25%)
        `,
        backgroundPosition: '20px 0, 20px 0, 0 0, 0 0',
        backgroundSize: '40px 40px',
        backgroundRepeat: 'repeat',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

export default GeometricBackground;